module.exports = __webpack_public_path__ + "static/img/407.4d9ccdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/407.png
// module id = 526
// module chunks = 3